import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { GridTableParametersService } from 'src/app/template/gridTemplate/gridTableParameters.service';
import { SharingDataService } from 'src/app/Services/sharing-data.service';
import { FromPicklistPipe } from 'src/app/shared/pipes/fromPicklistPipe.pipe';
import { FormularService } from 'src/app/Services/formular.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthentService, AuthenticationRole } from 'src/app/Services/authent.service';
import {Observable} from 'rxjs';
import {filter, map, startWith} from 'rxjs/operators';
import { newArray } from '@angular/compiler/src/util';
import { autocompleteValidator } from 'src/app/template/customValidators/autocompleteValidator';
import { stringify } from 'querystring';

@Component({
  selector: 'app-coordinate-search-page',
  templateUrl: './coordinate-search-page.component.html',
  styleUrls: ['./coordinate-search-page.component.css']
})
export class CoordinateSearchPageComponent implements OnInit {
  @Input() public CoordinateSearchFormGroup: FormGroup;
  @Input() public OverviewForm;
  @Output() public submitFormular = new EventEmitter();

  groupName="MS_REQ_N";
  resourceDefinition;
  Picklist;
  searchMethodFormular;
  showLoading = false;
  routerString;
  g3e_fid;

  constructor(
    public grid: GridTableParametersService,
    private shareData: SharingDataService,
    public fromPicklist: FromPicklistPipe,
    public formularService: FormularService,
    public router: Router,
    public authService: AuthentService,
    private route: ActivatedRoute,
  ) { }

  searchMethodFormularIn = [
    { formControlName: "SEARCH_METHOD", picklist: "V_MS_SEARCH_METHOD_INT_VL_T", listOfValues: null, input: false, required: true, readonly: false, datepicker: false, datepickerType: null, datepickerMax: null, datepickerMin: null, textArea: false, function: "searchMethod", title: "cptn_Navigation" },
  ]

  searchMethodFormularEx = [
    { formControlName: "SEARCH_METHOD", picklist: "V_MS_SEARCH_METHOD_VL_T", listOfValues: null, input: false, required: true, readonly: false, datepicker: false, datepickerType: null, datepickerMax: null, datepickerMin: null, textArea: false, function: "searchMethod", title: "cptn_Navigation" },
  ]

  addressFormular = [
    { formControlName: "VPO_MUNICIPALITY_DEFAULT",  picklist: null, autocomplete: true, autocompleteValues: null,  input: false, required: true, readonly: false, datepicker: false, datepickerType: null, datepickerMax: null, datepickerMin: null, textArea: false, function: "getStreet", title: "cptn_Navigation_Address" },
    { formControlName: "STREET",  picklist: null, autocomplete: true, autocompleteValues: null, input: false, required: true, readonly: false, datepicker: false, datepickerType: null, datepickerMax: null, datepickerMin: new Date(), textArea: false, function: "getHouseNumber", title: null },
    { formControlName: "VPO_HOUSENUMBER_DEFAULT",  picklist: null, autocomplete: true, autocompleteValues: null, input: false, required: true, readonly: false, datepicker: false, datepickerType: null, datepickerMax: null, datepickerMin: null, textArea: false, function: "getAddressOutput", title: null },
    { formControlName: "ADDRESS_ID",  picklist: null, listOfValues: null, input: false, required: false, readonly: true, datepicker: false, datepickerType: null, datepickerMax: null, datepickerMin: null, textArea: false, function: "", title: "cptn_Output" },
    { formControlName: "X_LOC_COORD",  picklist: null, listOfValues: null, input: false, required: false, readonly: true, datepicker: false, datepickerType: null, datepickerMax: null, datepickerMin: null, textArea: false, function: "", title: null },
    { formControlName: "Y_LOC_COORD",  picklist: null, listOfValues: null, input: false, required: false, readonly: true, datepicker: false, datepickerType: null, datepickerMax: null, datepickerMin: null, textArea: false, function: "", title: null },
  ]

  parcelFormular = [
    { formControlName: "VPO_CADASTRALUNIT_DEFAULT",  picklist: null, autocomplete: true, autocompleteValues: null, input: false, required: true, readonly: false, datepicker: false, datepickerType: null, datepickerMax: null, datepickerMin: null, textArea: false, function: "getCadastralSection", title: "cptn_Navigation_Parcel" },
    { formControlName: "VPO_CADASTRALSECTION_DEFAULT",  picklist: null, autocomplete: true, autocompleteValues: null, input: false, required: true, readonly: false, datepicker: false, datepickerType: null, datepickerMax: null, datepickerMin: null, textArea: false, function: "getNominator", title: null },
    { formControlName: "VPO_NOMINATOR_DEFAULT",  picklist: null, autocomplete: true, autocompleteValues: null, input: false, required: true, readonly: false, datepicker: false, datepickerType: null, datepickerMax: null, datepickerMin: null, textArea: false, function: "getDenominator", title: null },
    { formControlName: "VPO_DENOMINATOR_DEFAULT",  picklist: null, autocomplete: true, autocompleteValues: null, input: false, required: true, readonly: false, datepicker: false, datepickerType: null, datepickerMax: null, datepickerMin: null, textArea: false, function: "getParcelOutput", title: null },
    { formControlName: "PARCEL_ID",  picklist: null, listOfValues: null, input: false, required: false, readonly: true, datepicker: false, datepickerType: null, datepickerMax: null, datepickerMin: null, textArea: false, function: "", title: "cptn_Output" },
    { formControlName: "X_LOC_COORD",  picklist: null, listOfValues: null, input: false, required: false, readonly: true, datepicker: false, datepickerType: null, datepickerMax: null, datepickerMin: null, textArea: false, function: "", title: null },
    { formControlName: "Y_LOC_COORD",  picklist: null, listOfValues: null, input: false, required: false, readonly: true, datepicker: false, datepickerType: null, datepickerMax: null, datepickerMin: null, textArea: false, function: "", title: null },
  ]

  manualRequestFormular = [
    { formControlName: "NOTE", picklist: null, listOfValues: null, input: false, required: true, readonly: false, datepicker: false, datepickerType: null, datepickerMax: null, datepickerMin: null, textArea: true, function: "onSubmit", title: "cptn_Navigation_Manual" },
  ]

  coordinateFormular = [
    { formControlName: "X_LOC_COORD", picklist: null, listOfValues: null, inputNumber: true, required: true, readonly: false, datepicker: false, datepickerType: null, datepickerMax: null, datepickerMin: null, textArea: false, function: "onSubmit", title: "cptn_Navigation_Coordinates" },
    { formControlName: "Y_LOC_COORD", picklist: null, listOfValues: null, inputNumber: true, required: true, readonly: false, datepicker: false, datepickerType: null, datepickerMax: null, datepickerMin: null, textArea: false, function: "onSubmit", title: null },
  ]

  action(action) {
    this[action]();
  }

  onSubmit() {
    this.submitFormular.emit();
  }

  ngOnInit(): void {
    this.getUrlParams();
    if (this.router.url.indexOf("?") > 0) {
      this.routerString = this.router.url.substr(0, this.router.url.indexOf("?"));
    } else {
      this.routerString = this.router.url;
    }
    if (this.routerString != '/gipReqMan') {
      this.CoordinateSearchFormGroup.reset();
      if (this.authService.currentUser().ROLE == AuthenticationRole.ExternalAdmin || this.authService.currentUser().ROLE == AuthenticationRole.ExternalUser || this.authService.currentUser().ROLE == AuthenticationRole.Public) {
        this.externalOnInit();
      }
      if (this.authService.currentUser().ROLE == AuthenticationRole.InternalAdmin || this.authService.currentUser().ROLE == AuthenticationRole.InternalUser) {
        this.internalOnInit();
      }
    } else {
      for (var element in this.CoordinateSearchFormGroup.controls) {
        this.CoordinateSearchFormGroup.controls[element].setValidators(null);
      }
      if (this.CoordinateSearchFormGroup.value.SEARCH_METHOD == "1" || this.CoordinateSearchFormGroup.value.SEARCH_METHOD == "2" || this.CoordinateSearchFormGroup.value.SEARCH_METHOD == "4") {
        this.searchMethodFormularIn.forEach(searchMethodFormularInElement => {
          searchMethodFormularInElement.function = null;
          searchMethodFormularInElement.readonly = true;
        });
        this.addressFormular.forEach(addressFormularElement => {
          addressFormularElement.function = null;
          addressFormularElement.readonly = true;
        });
        this.parcelFormular.forEach(parcelFormularElement => {
          parcelFormularElement.function = null;
          parcelFormularElement.readonly = true;
        });
        this.manualRequestFormular.forEach(manualRequestFormularElement => {
          manualRequestFormularElement.function = null;
          manualRequestFormularElement.readonly = true;
        });
        this.coordinateFormular.forEach(coordinateFormularElement => {
          coordinateFormularElement.function = null;
          coordinateFormularElement.readonly = true;
        });
      }
      this.internalOnInit();
    }

    this.shareData.currentResourceDefinition.subscribe(data => this.resourceDefinition = data);
    this.shareData.currentPicklist.subscribe(data => {
      this.Picklist = data;
      if(this.Picklist.V_MS_SEARCH_METHOD_INT_VL_T.length == 1){
        this.CoordinateSearchFormGroup.controls.SEARCH_METHOD.setValue(this.Picklist.V_MS_SEARCH_METHOD_INT_VL_T[0].key)
      }
      if(this.Picklist.V_MS_SEARCH_METHOD_VL_T.length == 1){
        this.CoordinateSearchFormGroup.controls.SEARCH_METHOD.setValue(this.Picklist.V_MS_SEARCH_METHOD_VL_T[0].key);
      }
    });
  }

  getUrlParams() {
    this.route.queryParams
      .subscribe(params => {
        if (params.g3e_fid != undefined) {
          this.g3e_fid = params.g3e_fid;
        }
      });
  }
  externalOnInit() {
    this.searchMethodFormular = this.searchMethodFormularEx;

  }

  internalOnInit() {
    this.searchMethodFormular = this.searchMethodFormularIn;
  }


  clear() {
    for (var element in this.CoordinateSearchFormGroup.controls) {
      if (element != "SEARCH_METHOD") {
        this.CoordinateSearchFormGroup.controls[element].setValidators(null);
      }
    }

    this.CoordinateSearchFormGroup.markAsUntouched();
    this.CoordinateSearchFormGroup.markAsPristine();
  }

  btnBackAction() {
    if (this.g3e_fid != undefined)
      this.router.navigate(["/gipReqManForm"], { queryParams: { g3e_fid: this.g3e_fid } });
  }

  searchMethod() {
    this.clear();
    if (this.CoordinateSearchFormGroup.value.SEARCH_METHOD == "2") {
      this.CoordinateSearchFormGroup.controls.X_LOC_COORD.setValue(null);
      this.CoordinateSearchFormGroup.controls.Y_LOC_COORD.setValue(null);
      this.CoordinateSearchFormGroup.controls.VPO_CADASTRALUNIT_DEFAULT.setValue(null);
      this.CoordinateSearchFormGroup.controls.VPO_CADASTRALSECTION_DEFAULT.setValue(null);
      this.CoordinateSearchFormGroup.controls.VPO_NOMINATOR_DEFAULT.setValue(null);
      this.CoordinateSearchFormGroup.controls.VPO_DENOMINATOR_DEFAULT.setValue(null);
      this.CoordinateSearchFormGroup.controls.PARCEL_ID.setValue(null);
      this.getCatastralUnit();
    }
    if (this.CoordinateSearchFormGroup.value.SEARCH_METHOD == "1") {
      this.CoordinateSearchFormGroup.controls.X_LOC_COORD.setValue(null);
      this.CoordinateSearchFormGroup.controls.Y_LOC_COORD.setValue(null);
      this.CoordinateSearchFormGroup.controls.STREET.setValue(null);
      this.CoordinateSearchFormGroup.controls.VPO_MUNICIPALITY_DEFAULT.setValue(null);
      this.CoordinateSearchFormGroup.controls.VPO_HOUSENUMBER_DEFAULT.setValue(null);
      this.CoordinateSearchFormGroup.controls.ADDRESS_ID.setValue(null);
      this.getMunicipality();
    }
    if (this.CoordinateSearchFormGroup.value.SEARCH_METHOD == "4") {
      this.CoordinateSearchFormGroup.controls.X_LOC_COORD.setValue(null);
      this.CoordinateSearchFormGroup.controls.Y_LOC_COORD.setValue(null);
    }
    this.onSubmit();
  }
  
  toUnicode(value: string){
    const chars = [`#`, `&`, `%`, `+`];
    const uni = [`%23`, `%26`, `%25`, `2B`];
    for(let i = 0; i < value.length; i++){
      for(let ii = 0; ii< chars.length; ii++){
        if(value[i] == chars[ii]){
          value = value.replace(value[i], uni[ii])
          i++;
        }
      }
    }
    return value;
  }
  
  makeAutocomplete(element, values){
    if(values.indexOf(null) >= 0){
      var index = values.indexOf(null);
      values.splice(index, 1);
    }
    element.autocompleteValues = this.CoordinateSearchFormGroup.controls[element.formControlName].valueChanges
    .pipe(
      filter(value => value !== null),
      startWith(''),
      map(value => values.filter(option => option.toLowerCase().indexOf(value.toLowerCase()) === 0))
    );
  }

  getMunicipality() {
    this.showLoading = true;
    this.CoordinateSearchFormGroup.controls.STREET.disable();
    this.CoordinateSearchFormGroup.controls.VPO_HOUSENUMBER_DEFAULT.disable();
    var urls = [
      `address/MS_ADDRESS?$apply=groupby((MUNICIPALITY))&$orderby=(MUNICIPALITY)`,
    ]

    this.formularService.getDataNoOdata(urls, (data) => {
      var municipalities = new Array();
      data[0].forEach(element => {
        municipalities.push(element.MUNICIPALITY)
      });
      this.addressFormular.forEach(element => {
        if (element.formControlName == "VPO_MUNICIPALITY_DEFAULT") {
          var values = [...municipalities];
          this.makeAutocomplete(element, values);
          this.CoordinateSearchFormGroup.controls.VPO_MUNICIPALITY_DEFAULT.setValidators([Validators.required, autocompleteValidator(values)])
        }
      });
      this.showLoading = false;
    });
  }

  getStreet() {
    this.CoordinateSearchFormGroup.controls.ADDRESS_ID.setValue(null);
    this.CoordinateSearchFormGroup.controls.X_LOC_COORD.setValue(null);
    this.CoordinateSearchFormGroup.controls.Y_LOC_COORD.setValue(null);
    this.CoordinateSearchFormGroup.controls.STREET.disable();
    this.CoordinateSearchFormGroup.controls.VPO_HOUSENUMBER_DEFAULT.disable();
    this.CoordinateSearchFormGroup.controls.STREET.reset();
    this.CoordinateSearchFormGroup.controls.VPO_HOUSENUMBER_DEFAULT.reset();
    if (this.CoordinateSearchFormGroup.controls.VPO_MUNICIPALITY_DEFAULT.status == "VALID") {
      // this.showLoading = true;
      var urls = [
        `address/MS_ADDRESS?$filter=MUNICIPALITY eq '${this.toUnicode(this.CoordinateSearchFormGroup.value.VPO_MUNICIPALITY_DEFAULT)}'&$apply=groupby((STREET,MUNICIPALITY))&$orderby=(STREET)`,
      ];

      this.formularService.getDataNoOdata(urls, (data) => {
        var streets = new Array();
        data[0].forEach(element => {
          streets.push(element.STREET);
        });
        this.addressFormular.forEach(element => {
          if (element.formControlName == "STREET") {
            var values = [...streets];
            this.makeAutocomplete(element, values);
            this.CoordinateSearchFormGroup.controls.STREET.setValidators([Validators.required, autocompleteValidator(values)])
            this.CoordinateSearchFormGroup.controls.STREET.enable();
          }
        });
        // this.showLoading = false;
      });
    }
  }

  getHouseNumber() {
    this.CoordinateSearchFormGroup.controls.ADDRESS_ID.setValue(null);
    this.CoordinateSearchFormGroup.controls.X_LOC_COORD.setValue(null);
    this.CoordinateSearchFormGroup.controls.Y_LOC_COORD.setValue(null);
    this.CoordinateSearchFormGroup.controls.VPO_HOUSENUMBER_DEFAULT.disable();
    this.CoordinateSearchFormGroup.controls.VPO_HOUSENUMBER_DEFAULT.reset();
    if (this.CoordinateSearchFormGroup.controls.VPO_MUNICIPALITY_DEFAULT.status == "VALID" && this.CoordinateSearchFormGroup.controls.STREET.status == "VALID") {
      // this.showLoading = true;
      var urls = [
        `address/MS_ADDRESS?$filter=MUNICIPALITY eq '${this.toUnicode(this.CoordinateSearchFormGroup.value.VPO_MUNICIPALITY_DEFAULT)}'
        AND STREET eq '${this.toUnicode(this.CoordinateSearchFormGroup.value.STREET)}'&$apply=groupby((STREET,MUNICIPALITY,HOUSENUMBER))&$orderby=(HOUSENUMBER)`,
      ];

      this.formularService.getDataNoOdata(urls, (data) => {
        var houseNumbers = new Array();
        data[0].forEach(element => {
          houseNumbers.push(element.HOUSENUMBER)
        });
        this.addressFormular.forEach(element => {
          if (element.formControlName == "VPO_HOUSENUMBER_DEFAULT") {
            var values = [...houseNumbers];
            this.CoordinateSearchFormGroup.controls.VPO_HOUSENUMBER_DEFAULT.setValidators([Validators.required, autocompleteValidator(values)])
            this.makeAutocomplete(element, values);
            this.CoordinateSearchFormGroup.controls.VPO_HOUSENUMBER_DEFAULT.enable();
          }
        });
        // this.showLoading = false;
      });
    }
  }

  getAddressOutput() {
    this.CoordinateSearchFormGroup.controls.ADDRESS_ID.setValue(null);
    this.CoordinateSearchFormGroup.controls.X_LOC_COORD.setValue(null);
    this.CoordinateSearchFormGroup.controls.Y_LOC_COORD.setValue(null);
    if (this.CoordinateSearchFormGroup.controls.VPO_MUNICIPALITY_DEFAULT.status == "VALID" && this.CoordinateSearchFormGroup.controls.STREET.status == "VALID" && this.CoordinateSearchFormGroup.controls.VPO_HOUSENUMBER_DEFAULT.status == "VALID") {
      // this.showLoading = true;
      var urls = [
        `address/MS_ADDRESS?$filter=MUNICIPALITY eq '${this.toUnicode(this.CoordinateSearchFormGroup.value.VPO_MUNICIPALITY_DEFAULT)}'
        AND STREET eq '${this.toUnicode(this.CoordinateSearchFormGroup.value.STREET)}'
        AND HOUSENUMBER eq '${this.toUnicode(this.CoordinateSearchFormGroup.value.VPO_HOUSENUMBER_DEFAULT)}'`,
      ];

      this.formularService.getData(urls, (data) => {
        this.CoordinateSearchFormGroup.controls.ADDRESS_ID.setValue(data[0][0].ID);
        this.CoordinateSearchFormGroup.controls.X_LOC_COORD.setValue(data[0][0].X);
        this.CoordinateSearchFormGroup.controls.Y_LOC_COORD.setValue(data[0][0].Y);
        this.CoordinateSearchFormGroup.controls.LOCATION.setValue(data[0][0].LOCATION);
        this.onSubmit();
        // this.showLoading = false;
      });
    }
  }

  getCatastralUnit() {
    this.showLoading = true;
    this.CoordinateSearchFormGroup.controls.VPO_CADASTRALSECTION_DEFAULT.disable();
    this.CoordinateSearchFormGroup.controls.VPO_NOMINATOR_DEFAULT.disable();
    this.CoordinateSearchFormGroup.controls.VPO_DENOMINATOR_DEFAULT.disable();
    var urls = [
      `address/MS_PARCEL?$apply=groupby((CADASTRALUNIT))&$orderby=(CADASTRALUNIT)`,
    ];

    this.formularService.getDataNoOdata(urls, (data) => {
      var cadastralUnits = new Array();
      data[0].forEach(element => {
        cadastralUnits.push(element.CADASTRALUNIT)
      });
      this.parcelFormular.forEach(element => {
        if (element.formControlName == "VPO_CADASTRALUNIT_DEFAULT") {
          var values = [...cadastralUnits];
          this.CoordinateSearchFormGroup.controls.VPO_CADASTRALUNIT_DEFAULT.setValidators([Validators.required, autocompleteValidator(values)])
          this.makeAutocomplete(element, values);
        }
      });
      this.showLoading = false;
    });
  }

  getCadastralSection() {
    this.CoordinateSearchFormGroup.controls.PARCEL_ID.setValue(null);
    this.CoordinateSearchFormGroup.controls.X_LOC_COORD.setValue(null);
    this.CoordinateSearchFormGroup.controls.Y_LOC_COORD.setValue(null);
    this.CoordinateSearchFormGroup.controls.VPO_CADASTRALSECTION_DEFAULT.disable();
    this.CoordinateSearchFormGroup.controls.VPO_NOMINATOR_DEFAULT.disable();
    this.CoordinateSearchFormGroup.controls.VPO_DENOMINATOR_DEFAULT.disable();
    this.CoordinateSearchFormGroup.controls.VPO_CADASTRALSECTION_DEFAULT.reset();
    this.CoordinateSearchFormGroup.controls.VPO_NOMINATOR_DEFAULT.reset();
    this.CoordinateSearchFormGroup.controls.VPO_DENOMINATOR_DEFAULT.reset();
    if (this.CoordinateSearchFormGroup.controls.VPO_CADASTRALUNIT_DEFAULT.status == "VALID") {
      // this.showLoading = true;
      var urls = [
        `address/MS_PARCEL?$filter=CADASTRALUNIT eq '${this.toUnicode(this.CoordinateSearchFormGroup.value.VPO_CADASTRALUNIT_DEFAULT)}'&$apply=groupby((CADASTRALUNIT,CADASTRALSECTION))&$orderby=(CADASTRALSECTION)`,
      ];

      this.formularService.getDataNoOdata(urls, (data) => {
        var cadastralSections = new Array();
        data[0].forEach(element => {
          cadastralSections.push(element.CADASTRALSECTION)
        });
        this.parcelFormular.forEach(element => {
          if (element.formControlName == "VPO_CADASTRALSECTION_DEFAULT") {
            var values = [...cadastralSections];
            this.CoordinateSearchFormGroup.controls.VPO_CADASTRALSECTION_DEFAULT.setValidators([Validators.required, autocompleteValidator(values)])
            this.makeAutocomplete(element, values);
            this.CoordinateSearchFormGroup.controls.VPO_CADASTRALSECTION_DEFAULT.enable();
          }
        });
        // this.showLoading = false;
      });
    }
  }

  getNominator() {
    this.CoordinateSearchFormGroup.controls.PARCEL_ID.setValue(null);
    this.CoordinateSearchFormGroup.controls.X_LOC_COORD.setValue(null);
    this.CoordinateSearchFormGroup.controls.Y_LOC_COORD.setValue(null);
    this.CoordinateSearchFormGroup.controls.VPO_NOMINATOR_DEFAULT.disable();
    this.CoordinateSearchFormGroup.controls.VPO_DENOMINATOR_DEFAULT.disable();
    this.CoordinateSearchFormGroup.controls.VPO_NOMINATOR_DEFAULT.reset();
    this.CoordinateSearchFormGroup.controls.VPO_DENOMINATOR_DEFAULT.reset();
    if (this.CoordinateSearchFormGroup.controls.VPO_CADASTRALUNIT_DEFAULT.status == "VALID" && this.CoordinateSearchFormGroup.controls.VPO_CADASTRALSECTION_DEFAULT.status == "VALID") {
      // this.showLoading = true;
      var urls = [
        `address/MS_PARCEL?$filter=CADASTRALUNIT eq '${this.toUnicode(this.CoordinateSearchFormGroup.value.VPO_CADASTRALUNIT_DEFAULT)}'
        AND CADASTRALSECTION eq '${this.toUnicode(this.CoordinateSearchFormGroup.value.VPO_CADASTRALSECTION_DEFAULT)}'
        &$apply=groupby((CADASTRALUNIT,CADASTRALSECTION,NOMINATOR))&$orderby=(NOMINATOR)`,
      ];

      this.formularService.getDataNoOdata(urls, (data) => {
        var nominators = new Array();
        data[0].forEach(element => {
          nominators.push(element.NOMINATOR)
        });
        this.parcelFormular.forEach(element => {
          if (element.formControlName == "VPO_NOMINATOR_DEFAULT") {
            var values = [...nominators];
            this.CoordinateSearchFormGroup.controls.VPO_NOMINATOR_DEFAULT.setValidators([Validators.required, autocompleteValidator(values)])
            this.makeAutocomplete(element, values);
            this.CoordinateSearchFormGroup.controls.VPO_NOMINATOR_DEFAULT.enable();
          }
        });
        // this.showLoading = false;
      });
    }
  }

  getDenominator() {
    this.CoordinateSearchFormGroup.controls.PARCEL_ID.setValue(null);
    this.CoordinateSearchFormGroup.controls.X_LOC_COORD.setValue(null);
    this.CoordinateSearchFormGroup.controls.Y_LOC_COORD.setValue(null);
    this.CoordinateSearchFormGroup.controls.VPO_DENOMINATOR_DEFAULT.disable();
    this.CoordinateSearchFormGroup.controls.VPO_DENOMINATOR_DEFAULT.reset();
    if (this.CoordinateSearchFormGroup.controls.VPO_CADASTRALUNIT_DEFAULT.status == "VALID" && this.CoordinateSearchFormGroup.controls.VPO_CADASTRALSECTION_DEFAULT.status == "VALID" && this.CoordinateSearchFormGroup.controls.VPO_NOMINATOR_DEFAULT.status == "VALID") {
      // this.showLoading = true;
      var urls = [
        `address/MS_PARCEL?$filter=CADASTRALUNIT eq '${this.toUnicode(this.CoordinateSearchFormGroup.value.VPO_CADASTRALUNIT_DEFAULT)}'
        AND CADASTRALSECTION eq '${this.toUnicode(this.CoordinateSearchFormGroup.value.VPO_CADASTRALSECTION_DEFAULT)}'
        AND NOMINATOR eq '${this.toUnicode(this.CoordinateSearchFormGroup.value.VPO_NOMINATOR_DEFAULT)}'
        &$apply=groupby((CADASTRALUNIT,CADASTRALSECTION,NOMINATOR,DENOMINATOR))&$orderby=(DENOMINATOR)`,
      ];

      this.formularService.getDataNoOdata(urls, (data) => {
        var denominators = new Array();
        data[0].forEach(element => {
          denominators.push(element.DENOMINATOR)
        });
        this.parcelFormular.forEach(element => {
          if (element.formControlName == "VPO_DENOMINATOR_DEFAULT") {
            var values = [...denominators];
            this.CoordinateSearchFormGroup.controls.VPO_DENOMINATOR_DEFAULT.setValidators([Validators.required, autocompleteValidator(values)])
            this.makeAutocomplete(element, values);
            this.CoordinateSearchFormGroup.controls.VPO_DENOMINATOR_DEFAULT.enable();
          }
        });
        // this.showLoading = false;
      });
    }
  }

  getParcelOutput() {
    this.CoordinateSearchFormGroup.controls.PARCEL_ID.setValue(null);
    this.CoordinateSearchFormGroup.controls.X_LOC_COORD.setValue(null);
    this.CoordinateSearchFormGroup.controls.Y_LOC_COORD.setValue(null);
    if (this.CoordinateSearchFormGroup.controls.VPO_CADASTRALUNIT_DEFAULT.status == "VALID" && this.CoordinateSearchFormGroup.controls.VPO_CADASTRALSECTION_DEFAULT.status == "VALID" && this.CoordinateSearchFormGroup.controls.VPO_NOMINATOR_DEFAULT.status == "VALID" && this.CoordinateSearchFormGroup.controls.VPO_DENOMINATOR_DEFAULT.status == "VALID") {
      // this.showLoading = true;
      var urls = [
        `address/MS_PARCEL?$filter=CADASTRALUNIT eq '${this.toUnicode(this.CoordinateSearchFormGroup.value.VPO_CADASTRALUNIT_DEFAULT)}'
        AND CADASTRALSECTION eq '${this.toUnicode(this.CoordinateSearchFormGroup.value.VPO_CADASTRALSECTION_DEFAULT)}'
        AND NOMINATOR eq '${this.toUnicode(this.CoordinateSearchFormGroup.value.VPO_NOMINATOR_DEFAULT)}'
        AND DENOMINATOR eq '${this.toUnicode(this.CoordinateSearchFormGroup.value.VPO_DENOMINATOR_DEFAULT)}'`,
      ];

      this.formularService.getData(urls, (data) => {
        this.CoordinateSearchFormGroup.controls.PARCEL_ID.setValue((data[0][0].G3E_FID).toString());
        this.CoordinateSearchFormGroup.controls.X_LOC_COORD.setValue(data[0][0].X_CENTER);
        this.CoordinateSearchFormGroup.controls.Y_LOC_COORD.setValue(data[0][0].Y_CENTER);
        this.CoordinateSearchFormGroup.controls.LOCATION.setValue(data[0][0].LOCATION);
        this.onSubmit();
        // this.showLoading = false;
      });
    }
  }

}
